import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import DistributorsList from "./views/DistributorsList";
import * as distributorsActions from "../../../redux/modules/distributors";
import * as optionsActions from "../../../redux/modules/options";

const mapStateToProps = state => {
  return {
    loading: state.distributors.loading,
    success: state.distributors.success,
    message: state.distributors.message,
    data: state.distributors.data,
    total: state.distributors.total,
    limit: state.distributors.limit,
    page: state.distributors.page,
    order: state.distributors.order,
    orderMode: state.distributors.orderMode,
    deleted: state.distributors.deleted,
    deletedId: state.distributors.deletedId,
    token: state.distributors.token,

    headerLoaded: state.options.headerLoaded,
    translate: state.options.translate,
    searchModel: state.options.searchModel,
    columns: state.options.columns,
    columnsOrder: state.options.columnsOrder
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getListHeader: optionsActions.getGridInfo,
      optionsReset: optionsActions.reset,

      getList: distributorsActions.distributorsList,
      delete: distributorsActions.distributorDelete,
      setLoading: distributorsActions.setLoading,
      reset: distributorsActions.reset
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DistributorsList);
